import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { bufferTime, filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class RouterService {
    private readonly location = inject(Location);

    private paramRemovalQueue$ = new Subject<string>();

    constructor() {
        this.paramRemovalQueue$
            .pipe(
                takeUntilDestroyed(),
                bufferTime(50),
                filter((params) => params.length > 0)
            )
            .subscribe((params) => this.processRemoveQueryParams(params));
    }

    removeQueryParam(param: string): void {
        this.paramRemovalQueue$.next(param);
    }

    private processRemoveQueryParams(paramsToRemove: string[]): void {
        const currentParams = new URLSearchParams(window.location.search);

        for (const param of paramsToRemove) {
            currentParams.delete(param);
        }

        const query = currentParams.toString();
        const path = this.location.path().split('?')[0];

        this.location.replaceState(path, query);
    }
}
